/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TeamsRecipient
 */
export interface TeamsRecipient {
    /**
     * 
     * @type {string}
     * @memberof TeamsRecipient
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof TeamsRecipient
     */
    name?: string;
}

export function TeamsRecipientFromJSON(json: any): TeamsRecipient {
    return TeamsRecipientFromJSONTyped(json, false);
}

export function TeamsRecipientFromJSONTyped(json: any, ignoreDiscriminator: boolean): TeamsRecipient {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
    };
}

export function TeamsRecipientToJSON(value?: TeamsRecipient | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
    };
}


